import CheckIcon from '../../assets/check.svg';
import ErrorIcon from '../../assets/error.svg';
import LoaderIcon from '../../assets/loader.svg';

export const successIcon = {
  // @ts-ignore -- svgr config is not working properly, className is not in IntrinsictAttributes, but it compiles
  icon: <CheckIcon className={'icon icon--success'} />,
};
export const errorIcon = {
  // @ts-ignore -- svgr config is not working properly, className is not in IntrinsictAttributes, but it compiles
  icon: <ErrorIcon className={'icon icon--error'} />,
};

export const loaderIcon = {
  // @ts-ignore -- svgr config is not working properly, className is not in IntrinsictAttributes, but it compiles
  icon: <LoaderIcon className={'icon icon--error'} />,
};
